import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

const CheckBox = styled.span<{ isEnabled?: boolean }>`
    display: inline-block;
    position: relative;
    width: 11px;
    height: 11px;
    background-color: ${props => (props.isEnabled ? '#FFFFFF' : '#E2E3E5')};
    border-radius: 3px;
    border-style: solid;
    border-color: #969497;
    margin-right: 10px;
    margin-top: 7px;
    border-width: 1px;
    flex-shrink: 0;
    cursor: ${props => (props.isEnabled ? 'pointer' : 'default')};
`;

const CheckMark = styled.i<{ isEnabled?: boolean }>`
    position: absolute;
    color: ${props => (props.isEnabled ? '#87a658' : '#7a7a7a')};
    top: -8px;
    right: -8px;
    font-size: 19px;
    font-weight: 500;
`;

const CheckBoxContainer = styled.div`
    user-select: none;
    cursor: pointer;
    display: flex;
`;

const CheckBoxText = styled.span<{ isEnabled?: boolean }>`
    font-size: 15px;
    cursor: ${props => (props.isEnabled ? 'pointer' : 'default')};
    color: ${props => (props.isEnabled ? '#000000' : '#7a7a7a')};
`;
interface Props {
    isEnabled?: boolean;
    isChecked: boolean;
    onClick?: (toggleState: boolean) => void;
    text?: string;
}
export const LocalContentCheckBox: FC<Props> = ({ onClick = () => {}, isEnabled = true, ...props }) => {
    const [isChecked, setIsChecked] = useState(props.isChecked || false);

    useEffect(() => {
        if (props.isChecked !== isChecked) {
            setIsChecked(props.isChecked);
        }
    }, [isChecked, props.isChecked]);

    function onClickHandler() {
        if (isEnabled) {
            const toggledCheckState = !isChecked;

            onClick(toggledCheckState);
            setIsChecked(toggledCheckState);
        }
    }

    const checkBox = (
        <CheckBox isEnabled={isEnabled} data-testid="legalConfirmationCheckbox">
            {isChecked ? (
                <CheckMark className="material-icons" isEnabled={isEnabled}>
                    check
                </CheckMark>
            ) : null}
        </CheckBox>
    );
    return (
        <CheckBoxContainer onClick={onClickHandler}>
            {checkBox}
            <CheckBoxText isEnabled={isEnabled} dangerouslySetInnerHTML={{ __html: props.text ?? '' }} />
        </CheckBoxContainer>
    );
};
